import type * as React from "react";
import { cn } from "../utils";

function Input({ className, type, ...props }: React.ComponentPropsWithRef<"input">) {
  return (
    <input
      type={type}
      className={cn(
        `
          flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm
          file:border-0 file:bg-transparent file:text-sm file:font-medium 
          ring-offset-background focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2
          text-foreground placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 read-only:bg-accent read-only:text-muted-foreground
          appearance-none [&::-webkit-calendar-picker-indicator]:hidden [&::-webkit-calendar-picker-indicator]:appearance-none
        `,
        className
      )}
      {...props}
    />
  );
}

export { Input };
